import { gql } from 'apollo-angular';

const GET_FILTER_INVOICES = gql`
    query getInvoices($searchText: String!, $filterStatus: String!) {
        getInvoices(searchText: $searchText, filterStatus: $filterStatus) {
            id
            buyerName
            supplierName
            invoiceNumber
            invoiceDate
            dueDate
            adjustDueDate
            status
            fundsSent
            postDate
            paymentDate
            paymentId
            paymentAmount
            fboStatus
            collectionUpdated
            collectionCreated
        }
    }
`;

export { GET_FILTER_INVOICES };
